import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message envoyé !", {
        description: "Merci pour ton message — nous te répondons sous 48 h ouvrées.",
      });
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Envoi impossible", {
        description: "Réessaie dans un instant ou écris-nous à Bathilysamir22@gmail.com.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={submit} data-testid="contact-form">
      <div className="cf-title">Une question ? Écris-nous</div>
      <div className="cf-row">
        <input
          type="text"
          placeholder="Ton nom"
          value={form.name}
          onChange={update("name")}
          required
          data-testid="contact-name-input"
        />
        <input
          type="email"
          placeholder="Ton email"
          value={form.email}
          onChange={update("email")}
          required
          data-testid="contact-email-input"
        />
      </div>
      <textarea
        placeholder="Ton message…"
        rows={4}
        value={form.message}
        onChange={update("message")}
        required
        data-testid="contact-message-input"
      />
      <button type="submit" className="btn cf-submit" disabled={sending} data-testid="contact-submit-btn">
        {sending ? "Envoi en cours…" : (
          <>
            Envoyer le message
            <Send size={15} />
          </>
        )}
      </button>
    </form>
  );
}
